<app-modal id="add-wish">
  <div class="modal-content">
    <p class="title">Regarder à nouveau cette recette plus tard ?</p>
    <p>Connectez-vous pour ajouter la recette à vos favoris.</p>
  </div>
  <div class="modal-btn">
    <button type="button" class="link" (click)="closeModal('add-wish');">Fermer</button>
    <a class="link-main" (click)="closeModalLogin('add-wish');" [routerLink]="'/connexion'">Se connecter</a>
  </div>
</app-modal>

<a *ngFor="let recipe of currentRecipes; let index = index;" class="recipe"
   [routerLink]="'/recette/'+ recipe.domainTitle + '/' + recipe.category + '/' + recipe.subCategory + '/' + recipe.id">
  <div class="picture-recipe">
    <img class="first-picture" *ngIf="recipe.imageUrl && recipe.imageUrl != ''" width="612" height="407"
         src="{{recipe.imageUrl}}"
         alt="Image recette {{recipe.title}}" loading="lazy"/>
    <div *ngIf="!recipe.imageUrl || recipe.imageUrl == ''"
         class="color bg-color-{{recipe.userId.charCodeAt(0) % 5}}"></div>

    <div class="view-info" (click)="addWish(recipe, $event)">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 16.325 13.125">
        <g id="Groupe_239" data-name="Groupe 239" transform="translate(0 0)">
          <path id="Tracé_361" data-name="Tracé 361" d="M157.632,330.4a1.508,1.508,0,0,0-.292.034.752.752,0,0,1,.137.429.77.77,0,0,1-.773.773.751.751,0,0,1-.429-.137,1.694,1.694,0,0,0-.034.292,1.391,1.391,0,1,0,1.391-1.391Z" transform="translate(-154.022 -322.291)" fill="#602719"/>
          <path id="Tracé_362" data-name="Tracé 362" d="M454.432,330.4a1.508,1.508,0,0,0-.292.034.752.752,0,0,1,.137.429.77.77,0,0,1-.773.773.751.751,0,0,1-.429-.137,1.7,1.7,0,0,0-.034.292,1.391,1.391,0,1,0,2.783,0,1.408,1.408,0,0,0-1.391-1.391Z" transform="translate(-441.718 -322.291)" fill="#602719"/>
          <path id="Tracé_363" data-name="Tracé 363" d="M100.182,74.95a47.293,47.293,0,0,0-2.1-6.236,2.613,2.613,0,0,0-1.495-1.495c-.034-.1-.086-.206-.12-.309a1.345,1.345,0,0,0-1.477-.842l-.24.034a1.34,1.34,0,0,0-1.117,1.288c0,.155-.017.326-.017.5a2.693,2.693,0,0,0-.687,1.632,1.842,1.842,0,0,0-.876-.223,1.9,1.9,0,0,0-.876.223,2.558,2.558,0,0,0-.687-1.632,4.669,4.669,0,0,0-.017-.5A1.34,1.34,0,0,0,89.36,66.1l-.206-.034a1.334,1.334,0,0,0-1.477.842c-.034.1-.086.206-.12.309a2.663,2.663,0,0,0-1.494,1.495,51,51,0,0,0-2.1,6.236,3.617,3.617,0,0,0,7.112,1.323,1.984,1.984,0,0,0,1,.292,1.828,1.828,0,0,0,1-.292,3.617,3.617,0,0,0,7.112-1.323ZM87.522,77.819a2.25,2.25,0,1,1,2.25-2.25A2.258,2.258,0,0,1,87.522,77.819ZM92.074,75.5a.876.876,0,1,1,.876-.876A.88.88,0,0,1,92.074,75.5Zm4.552,2.319a2.25,2.25,0,1,1,2.25-2.25,2.258,2.258,0,0,1-2.25,2.25Z" transform="translate(-83.911 -66.051)" fill="#602719"/>
        </g>
      </svg>


      {{recipe.nbView}}
    </div>

    <div class="wish-btn" (click)="addWish(recipe, $event)">
      <svg *ngIf="recipe.wish" xmlns="http://www.w3.org/2000/svg" width="18" height="16"
           viewBox="0 0 24.913 23.226">
        <path class="add-wish"
              d="M6.229.065A6.02,6.02,0,0,0,0,5.839C0,11.779,9.852,20.219,11.957,22c2.1-1.737,11.957-10.232,11.957-16.26a5.836,5.836,0,0,0-4.5-5.515,6.462,6.462,0,0,0-6.979,2.463.609.609,0,0,1-.478.254.71.71,0,0,1-.5-.254A6.346,6.346,0,0,0,6.229.065Z"
              transform="translate(0.5 0.574)" fill="none" stroke="#602719" stroke-miterlimit="10" stroke-width="2"/>
      </svg>
      <svg *ngIf="!recipe.wish" xmlns="http://www.w3.org/2000/svg" width="18" height="16"
           viewBox="0 0 23.913 22">
        <path class="remove-wish"
              d="M6.229.065A6.02,6.02,0,0,0,0,5.839C0,11.779,9.852,20.219,11.957,22c2.1-1.737,11.957-10.232,11.957-16.26a5.836,5.836,0,0,0-4.5-5.515,6.462,6.462,0,0,0-6.979,2.463.609.609,0,0,1-.478.254.71.71,0,0,1-.5-.254A6.346,6.346,0,0,0,6.229.065Z"
              fill="#602719"/>
      </svg>
    </div>

    <div class="rate-info" (click)="addWish(recipe, $event)" *ngIf="recipe.averageRate">
      {{recipe.averageRate}}

      <svg id="Groupe_688" data-name="Groupe 688" xmlns="http://www.w3.org/2000/svg" width="15" height="14.5" viewBox="0 0 12 11.512">
        <path id="Tracé_333" data-name="Tracé 333" d="M120.741,54.293l1.061,2.149h0a1.021,1.021,0,0,0,.772.561l2.362.345a1.025,1.025,0,0,1,.569,1.751L123.8,60.772a1.021,1.021,0,0,0-.3.907l.4,2.362a1.025,1.025,0,0,1-1.49,1.081l-2.12-1.112a1.025,1.025,0,0,0-.956,0l-2.12,1.112a1.025,1.025,0,0,1-1.49-1.081l.4-2.362a1.021,1.021,0,0,0-.3-.907L114.126,59.1a1.025,1.025,0,0,1,.578-1.751L117.075,57a1.021,1.021,0,0,0,.772-.561l1.061-2.149a1.028,1.028,0,0,1,1.833,0Z" transform="translate(-113.816 -53.73)" fill="#d8953a"/>
      </svg>

    </div>

  </div>


  <div class="recipe-sub-information">

    <div class="text-information">
      <div class="block-picture-user">
        <app-img-or-letter-picture-component [userPicture]="recipe.userPicture"
                                             [textForOneLetter]="recipe.username"></app-img-or-letter-picture-component>
      </div>

      <div class="right">
        <h3 class="title">
          {{recipe.title}}
        </h3>
        <div class="sub-title">
          <div class="username">
            {{recipe.username}}
              <img class="verified" *ngIf="recipe.verified" src="/assets/images/user/verified-circle-white.svg"
                   width="12" height="12"
                   alt="Utilisateur vérfifié" loading="lazy">
          </div>
          <div class="divider-dot"></div>
          <p class="date">
            {{recipe.createdDate | dateAgo}}
          </p>
        </div>

      </div>

    </div>

      <div class="all-chip-tag">
        <div *ngFor="let tag of recipe.tags" class="chip-tag">
          {{tag.tagLabel}}
        </div>
      </div>

    </div>
</a>
